import { Ref, useMemo, useRef } from "react";
import { mergeRefs } from "../utils/merge-refs";

export const useMergedRefs = <T extends HTMLElement>(ref: Ref<T>) => {
  const currentRef = useRef<T>(null);

  const mergedRefs = useMemo(() => mergeRefs(ref, currentRef), [ref]);

  return {
    currentRef,
    mergedRefs,
  };
};
